import { faCreditCard } from '@fortawesome/pro-duotone-svg-icons'
import { memo } from 'react'

import { BUY_POINTS_PROVIDER } from '../../constants/pointsExchange'
import BackButton from '../shared/button/BackButton'
import BuyPointsCard from './BuyPointsCard'

const BuyPoints = ({
  selectedProvider,
  tokenProfile,
  t,
  onSelectProvider,
  onBackAction
  // onSubmitBuyPoints,
  // dispatchActionExchange,
  // exchangeProviderProfile,
  // buyPointsProfile
}) => {
  const buyPointsProvidersWithMiles = tokenProfile.buyPointsProvidersWithMiles
  const allProviders = [
    ...(tokenProfile.enablePurchasePointsWithCreditCard
      ? [
          {
            name: t('buy-points.credit-card'),
            description: t('buy-points.purchasing-points-conversion-desc'),
            icon: faCreditCard,
            ...BUY_POINTS_PROVIDER.CREDIT_CARD
          }
        ]
      : []),
    ...(buyPointsProvidersWithMiles.length
      ? [
          {
            ...buyPointsProvidersWithMiles[0],
            description: t('buy-points.buy-points-with-miles-desc', {
              name: buyPointsProvidersWithMiles[0].name,
              tokenName: tokenProfile.name
            })
          }
        ]
      : [])
  ]
  return (
    <>
      {selectedProvider && <BackButton t={t} onClick={onBackAction} />}
      {/* <PageHeaderWrapper
        label={t('buy-points.buy-points')}
        description={buildDescription(selectedProvider, t, tokenProfile.name)}
        icon={faCirclePlus}
        header
      /> */}
      {selectedProvider ? (
        <h1>Calculator</h1>
      ) : (
        allProviders?.map((provider, index) => (
          <BuyPointsCard
            key={index}
            provider={provider}
            t={t}
            onClick={() => onSelectProvider(provider)}
          />
        ))
      )}
    </>
  )
}

export default memo(BuyPoints)

// const buildDescription = (provider, t, tokenName) => {
//   if (provider) {
//     return t('buy-points.enter-amount-to-buy', { tokenName })
//   }
//   return t('buy-points.buy-points-desc')
// }
